import { render, staticRenderFns } from "./MedecinDetailThesecreate.vue?vue&type=template&id=d9c916fe&"
import script from "./MedecinDetailThesecreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailThesecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports